import type { Tickets } from "@/src/gql/graphql";
import { TICKET_CONFIG } from "@/features/tickets/components/TicketConfig";
import { ENHANCED_TICKET_DETAIL_CONFIG } from "@/features/tickets/components/TicketDetailConfig";
import { useTicketsConfigEnhancer } from "@/lib/hooks/api/shared/config-enhancers";
import { getFieldValue } from "@/components/shared/UniversalCRMTable/components/SimpleTable/tableCellFieldValue";
import { defineEntity } from "../types";

// ============================================================================
// TICKETS ENTITY DEFINITION
// ============================================================================
// Single source of truth for all tickets UI configuration.
// Column change: edit tableConfig.fields (features/tickets/config/fields/).
// New saved view: edit features/tickets/config/saved-views/ticket-saved-views.ts.
// Custom filter hook: add to tableConfig.customFilterHooks in TicketConfig.ts.
// ============================================================================

export const ticketsEntity = defineEntity<Tickets>({
  tableConfig: TICKET_CONFIG,

  detailConfig: ENHANCED_TICKET_DETAIL_CONFIG,

  synthesizeField(item, fieldId) {
    return getFieldValue(item, fieldId);
  },

  // Injects dynamic tag options into fields at render time
  useConfigEnhancer: (config) => useTicketsConfigEnhancer({ config: config as any }),
});
